import { render, staticRenderFns } from "./wissen.vue?vue&type=template&id=5f532f71&"
import script from "./wissen.vue?vue&type=script&lang=js&"
export * from "./wissen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports